import { FC, CSSProperties, ReactNode } from "react";
import { Link } from "react-router-dom";
import styles from "./index.module.css";

interface IProps {
  title: string;
  titleAlign?: "left" | "right";
  children: ReactNode;
  learnMoreLink?: string;
  // Stable hook for a GTM click trigger to key off — this component is shared
  // by the Crystal and MSP Plan panels, whose "Learn More" links otherwise
  // render identical text and can't be told apart by content alone.
  gtmId?: string;
  style?: CSSProperties;
}

const BookmarkCard: FC<IProps> = ({ title, titleAlign = "left", children, learnMoreLink, gtmId, style }) => {
  return (
    <div className={styles.card} style={style}>
      <div className={`${styles.tab} ${styles[titleAlign]}`}>{title}</div>
      {children}
      {learnMoreLink !== undefined && (
        <Link to={learnMoreLink} className={styles.learnMore} data-gtm-id={gtmId}>
          <span>Learn More</span>
          <img src="/images/right-arrow.svg" alt="Learn More" />
        </Link>
      )}
    </div>
  );
};

export default BookmarkCard;
